module.exports = __webpack_public_path__ + "static/media/airline@lowrez.d93f27bd.jpg";